import type { Reservation } from "@b2bportal/lodging-api";
import {
  TripHeader as SharedTripHeader,
  useHotelTripHeader,
} from "@/components";

interface TripHeaderProps {
  className?: string;
  reservation: Reservation;
  isCfarExercised?: boolean;
}

export const TripHeader = ({
  reservation,
  className,
  isCfarExercised,
}: TripHeaderProps) => {
  const tripHeaderProps = useHotelTripHeader({
    reservation,
    className,
    isCfarExercised,
  });

  return <SharedTripHeader {...tripHeaderProps} />;
};
